module.exports = __webpack_public_path__ + "img/24@2x.0e53b396.png";